import type { VariableV1NodeProps } from "@storytell/rich-text";
import type { VariableKind } from "@storytell/types/richText";
import { assertExhaustive } from "@storytell/types/richText";
import { Match, Switch } from "solid-js";
import { VariableV1Asset } from "./VariableV1Asset";
import { VariableV1Concept } from "./VariableV1Concept";
import { VariableV1Label } from "./VariableV1Label";
import { VariableV1View } from "./VariableV1View";

/**
 * Renderer to Be used in the Prompt Editor, it accepts props from the VariableV1 extension
 */
export const VariableV1EditorRenderer = (props: VariableV1NodeProps) => (
  <VariableV1StaticRenderer
    type={props.node.attrs.type as VariableKind}
    onDelete={props.deleteNode}
    notInPromptBar={props.notInPromptBar}
    id={props.node.attrs.id}
    selected={props.selected}
    isEditable={props.editor.isEditable}
  />
);
/**
 * Renderer to Be used in the Prompt Static Renderer, it accepts props from the PromptStaticRenderer
 * Doesn't rely on the tiptap editor instance or context
 */
export const VariableV1StaticRenderer = (props: {
  type: VariableKind;
  notInPromptBar?: boolean;
  id: string;
  selected?: boolean;
  onDelete: () => void;
  isEditable?: boolean;
  text?: string;
}) => {
  return (
    <Switch>
      <Match when={props.type === "view"}>
        <VariableV1View {...props} />
      </Match>
      <Match when={props.type === "asset"}>
        <VariableV1Asset {...props} />
      </Match>
      <Match when={props.type === "concept"}>
        <VariableV1Concept {...props} />
      </Match>
      <Match when={props.type === "label"}>
        <VariableV1Label {...props} />
      </Match>
    </Switch>
  );
};
